/**
 * NativeWaves Content API v1
 *
 * Contact: support@nativewaves.com
 *
 * DO NOT EDIT THIS CLASS MANUALLY!
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class AudioStreamsApi extends runtime.BaseAPI {
    /**
     * Get a paginated list of audio streams.
     */
    async audioStreamsGetRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.environmentId !== undefined) {
            queryParameters['environmentId'] = requestParameters.environmentId;
        }
        if (requestParameters.repositoryId !== undefined) {
            queryParameters['repositoryId'] = requestParameters.repositoryId;
        }
        if (requestParameters.resourceState) {
            queryParameters['resourceState'] = requestParameters.resourceState;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.groups) {
            queryParameters['groups'] = requestParameters.groups;
        }
        if (requestParameters.excludeGrouped !== undefined) {
            queryParameters['excludeGrouped'] = requestParameters.excludeGrouped;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        if (requestParameters.owner !== undefined) {
            queryParameters['owner'] = requestParameters.owner;
        }
        if (requestParameters.prefix !== undefined) {
            queryParameters['prefix'] = requestParameters.prefix;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/audioStreams`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of audio streams.
     */
    async audioStreamsGet(requestParameters = {}, initOverrides) {
        const response = await this.audioStreamsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new audio stream.
     */
    async audioStreamsPostRaw(requestParameters, initOverrides) {
        if (requestParameters.audioStreamInsert === null ||
            requestParameters.audioStreamInsert === undefined) {
            throw new runtime.RequiredError('audioStreamInsert', 'Required parameter requestParameters.audioStreamInsert was null or undefined when calling audioStreamsPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/audioStreams`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.audioStreamInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new audio stream.
     */
    async audioStreamsPost(requestParameters, initOverrides) {
        const response = await this.audioStreamsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete a audio stream.
     */
    async audioStreamsStreamIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.streamId === null ||
            requestParameters.streamId === undefined) {
            throw new runtime.RequiredError('streamId', 'Required parameter requestParameters.streamId was null or undefined when calling audioStreamsStreamIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/audioStreams/{streamId}`.replace(`{${'streamId'}}`, String(requestParameters.streamId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a audio stream.
     */
    async audioStreamsStreamIdDelete(requestParameters, initOverrides) {
        await this.audioStreamsStreamIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get audio stream details.
     */
    async audioStreamsStreamIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.streamId === null ||
            requestParameters.streamId === undefined) {
            throw new runtime.RequiredError('streamId', 'Required parameter requestParameters.streamId was null or undefined when calling audioStreamsStreamIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/audioStreams/{streamId}`.replace(`{${'streamId'}}`, String(requestParameters.streamId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get audio stream details.
     */
    async audioStreamsStreamIdGet(requestParameters, initOverrides) {
        const response = await this.audioStreamsStreamIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of audio objects in a stream.
     */
    async audioStreamsStreamIdObjectsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.streamId === null ||
            requestParameters.streamId === undefined) {
            throw new runtime.RequiredError('streamId', 'Required parameter requestParameters.streamId was null or undefined when calling audioStreamsStreamIdObjectsGet.');
        }
        const queryParameters = {};
        if (requestParameters.resourceState) {
            queryParameters['resourceState'] = requestParameters.resourceState;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.groups) {
            queryParameters['groups'] = requestParameters.groups;
        }
        if (requestParameters.excludeGrouped !== undefined) {
            queryParameters['excludeGrouped'] = requestParameters.excludeGrouped;
        }
        if (requestParameters.timeRangeStart !== undefined) {
            queryParameters['timeRangeStart'] = requestParameters.timeRangeStart;
        }
        if (requestParameters.timeRangeEnd !== undefined) {
            queryParameters['timeRangeEnd'] = requestParameters.timeRangeEnd;
        }
        if (requestParameters.sortByTime !== undefined) {
            queryParameters['sortByTime'] = requestParameters.sortByTime;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/audioStreams/{streamId}/objects`.replace(`{${'streamId'}}`, String(requestParameters.streamId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of audio objects in a stream.
     */
    async audioStreamsStreamIdObjectsGet(requestParameters, initOverrides) {
        const response = await this.audioStreamsStreamIdObjectsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create an new audio object in an audio stream.
     */
    async audioStreamsStreamIdObjectsPostRaw(requestParameters, initOverrides) {
        if (requestParameters.streamId === null ||
            requestParameters.streamId === undefined) {
            throw new runtime.RequiredError('streamId', 'Required parameter requestParameters.streamId was null or undefined when calling audioStreamsStreamIdObjectsPost.');
        }
        if (requestParameters.audioStreamObjectInsert === null ||
            requestParameters.audioStreamObjectInsert === undefined) {
            throw new runtime.RequiredError('audioStreamObjectInsert', 'Required parameter requestParameters.audioStreamObjectInsert was null or undefined when calling audioStreamsStreamIdObjectsPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/audioStreams/{streamId}/objects`.replace(`{${'streamId'}}`, String(requestParameters.streamId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.audioStreamObjectInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create an new audio object in an audio stream.
     */
    async audioStreamsStreamIdObjectsPost(requestParameters, initOverrides) {
        const response = await this.audioStreamsStreamIdObjectsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit audio stream details.
     */
    async audioStreamsStreamIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.streamId === null ||
            requestParameters.streamId === undefined) {
            throw new runtime.RequiredError('streamId', 'Required parameter requestParameters.streamId was null or undefined when calling audioStreamsStreamIdPatch.');
        }
        if (requestParameters.audioStreamEdit === null ||
            requestParameters.audioStreamEdit === undefined) {
            throw new runtime.RequiredError('audioStreamEdit', 'Required parameter requestParameters.audioStreamEdit was null or undefined when calling audioStreamsStreamIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/audioStreams/{streamId}`.replace(`{${'streamId'}}`, String(requestParameters.streamId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.audioStreamEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit audio stream details.
     */
    async audioStreamsStreamIdPatch(requestParameters, initOverrides) {
        const response = await this.audioStreamsStreamIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const AudioStreamsGetResourceStateEnum = {
    Active: 'ACTIVE',
    Disposed: 'DISPOSED',
    Deleted: 'DELETED',
};
/**
 * @export
 */
export const AudioStreamsStreamIdObjectsGetResourceStateEnum = {
    Active: 'ACTIVE',
    Disposed: 'DISPOSED',
    Deleted: 'DELETED',
};
/**
 * @export
 */
export const AudioStreamsStreamIdObjectsGetSortByTimeEnum = {
    Desc: 'Desc',
    Asc: 'Asc',
};
//# sourceMappingURL=AudioStreamsApi.js.map